"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var _default = {
  version: '0.0.1',
  schema: '0.0.1',
  configuration: {
    boilerplate: {
      initial: 15
    }
  }
};
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/config/application-context/application-configuration.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ2ZXJzaW9uIiwic2NoZW1hIiwiY29uZmlndXJhdGlvbiIsImJvaWxlcnBsYXRlIiwiaW5pdGlhbCJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25maWcvYXBwbGljYXRpb24tY29udGV4dC9hcHBsaWNhdGlvbi1jb25maWd1cmF0aW9uLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcblx0dmVyc2lvbjogJzAuMC4xJyxcblx0c2NoZW1hOiAnMC4wLjEnLFxuXHRjb25maWd1cmF0aW9uOiB7XG5cdFx0Ym9pbGVycGxhdGU6IHtcblx0XHRcdGluaXRpYWw6IDE1LFxuXHRcdH0sXG5cdH0sXG59O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O2VBQWU7RUFDZEEsT0FBTyxFQUFFLE9BQU87RUFDaEJDLE1BQU0sRUFBRSxPQUFPO0VBQ2ZDLGFBQWEsRUFBRTtJQUNkQyxXQUFXLEVBQUU7TUFDWkMsT0FBTyxFQUFFO0lBQ1Y7RUFDRDtBQUNELENBQUM7QUFBQTtBQUFBO0FBQUE7QUFBQTtFQUFBO0VBQUE7SUFBQTtFQUFBO0VBQUE7QUFBQTtBQUFBO0FBQUE7RUFBQTtFQUFBO0FBQUEifQ==